import React, {useState} 					from 'react';

import Icon 								from '../Icon';
import ProgressBar 							from '../ProgressBar';
import Button								from '../Button';

import {useAppSelector}						from '../../../app/hooks';
import {DocumentProps}						from './interface';

import {ft_formatBytes}						from '../../functions/format';

import img_file								from '../../images/icon/file.svg';
import img_dotsVertical						from '../../images/icon/dots-vertical.svg';
import img_uploadFile						from '../../images/document/upload-file.svg';
import img_eye								from '../../images/icon/eye-open.svg';

import LANGUAGE								from '../../language';

import './Document.css';


function DocumentItem(props: DocumentProps) {
	const lang = useAppSelector(state => state.settings.lang);

	const [hover, set_hover] = useState(false);

	const TEXTE = LANGUAGE(lang);

	const ACTION = [
		{
			value:  'download',
			render: (
				<span className={`gray-${(props.percent || !props.onClickDownload) ? 300 : 700}`}>
					{TEXTE.global.download}
				</span>
			)
		},
		{
			value:  'delete',
			render: (
				<span className={(props.isValala || !props.onClickDelete) ? 'gray-300' : 'error-600'}>
					{TEXTE.global.delete}
				</span>
			)
		}
	];

	if (!props.filename || !props.size) {
		return (
			<div className={'documentEmpty'}>
				<div className={'documentEmptyImage'}>
					<img src={img_uploadFile} alt={''} />
				</div>
				<div className={'documentEmptyText'}>
					<span>{TEXTE.devices.noDocument}</span>
					<span>{TEXTE[props.documentType || 'devices'].noDocumentText}</span>
				</div>
			</div>
		);
	}

	return (
		<div
			onClick={props.onClick}
			className={'documentItem'}
			data-hover={!!props.onClick}
			onMouseEnter={props.onClick ? () => set_hover(true) : undefined}
			onMouseLeave={props.onClick ? () => set_hover(false) : undefined}
		>
			<Icon iconBorder icon={hover ? img_eye : img_file} />
			<div className={'documentItemText'}>
				<span className={'weight-500'}>{props.filename}</span>
				{props.creator && <span>{TEXTE.devices.uploadBy}<span className={'primary-600 weight-500'}>{props.creator}</span></span>}
				<span>{ft_formatBytes(props.size)}</span>

				{typeof props.percent === 'string' && <span className={'error-500 weight-500'}>{props.percent}</span>}
				{typeof props.percent === 'number' &&
					<div className={'documentItemProgress'}>
						<ProgressBar value={props.percent} />
						<span>{`${props.percent || 0}%`}</span>
					</div>
				}
			</div>
			{!props.hideActionIcon &&
				<div className={'documentItemDownloadIcon'} onClick={e => e.stopPropagation()}>
					<Button
						absoluteRight
						absoluteHideIcon
						size={'md'}
						absolute={ACTION}
						type={'tertiary-gray'}
						icon={img_dotsVertical}
						absoluteItemClassname={'text-xs weight-500'}
						onChangeAbsolute={(value) => {
							if (value === 'delete' && props.onClickDelete)
								return props.onClickDelete();
							if (value === 'download' && props.onClickDownload)
								return props.onClickDownload();
						}}
					/>
				</div>
			}
		</div>
	);
}

export default DocumentItem;